import { render } from "./TandartsSchijndel.vue?vue&type=template&id=25e3a08f&scoped=true"
import script from "./TandartsSchijndel.vue?vue&type=script&lang=js"
export * from "./TandartsSchijndel.vue?vue&type=script&lang=js"

import "./TandartsSchijndel.vue?vue&type=style&index=0&id=25e3a08f&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e3a08f"]])

export default __exports__